import { render, staticRenderFns } from "./Farmes.html?vue&type=template&id=c0c1a34a&external"
import script from "./Farmes.js?vue&type=script&lang=js&external"
export * from "./Farmes.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports